import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { CONTACT } from "./constants";

const TIERS = [
  {
    id: "baslangic",
    name: "Başlangıç",
    badge: "Küçük işletmeler için",
    price: "İletişime Geçin",
    desc: "Dijitale güçlü bir başlangıç yapmak isteyenler için temel paket.",
    features: [
      "Kurumsal Web Sitesi (5 sayfa)",
      "Mobil Uyumlu Tasarım",
      "Temel SEO Optimizasyonu",
      "WhatsApp & Telefon Butonu",
      "1 Yıl Ücretsiz Destek",
    ],
    popular: false,
  },
  {
    id: "profesyonel",
    name: "Profesyonel",
    badge: "En çok tercih edilen",
    price: "İletişime Geçin",
    desc: "Büyüme odaklı işletmelere özel, tüm dijital kanalları kapsayan paket.",
    features: [
      "Premium Web Sitesi (Sınırsız Sayfa)",
      "Google & Instagram Reklam Yönetimi",
      "Gelişmiş SEO Altyapısı",
      "Randevu / Sipariş Sistemi",
      "Aylık Performans Raporu",
      "Öncelikli Destek",
    ],
    popular: true,
  },
  {
    id: "kurumsal",
    name: "Kurumsal",
    badge: "Markalar ve zincirler için",
    price: "Özel Teklif",
    desc: "Tam kapsamlı dijital pazarlama ve özel yazılım çözümleri.",
    features: [
      "Özel Yazılım Çözümleri",
      "Tam Kapsamlı Dijital Pazarlama",
      "CRM & WhatsApp Otomasyonu",
      "Marka Kimliği Tasarımı",
      "7/24 Öncelikli Destek",
      "Atanmış Proje Yöneticisi",
    ],
    popular: false,
  },
];

export default function Pricing() {
  return (
    <section
      id="fiyatlandirma"
      data-testid="pricing-section"
      className="relative py-24 sm:py-32 bg-[var(--ab-bg-soft)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="ab-chip">Fiyatlandırma</span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
            Şeffaf paketler,
            <br />
            <span className="ab-text-gradient">size özel</span> teklifler.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Her işletmenin ihtiyacı farklıdır. Aşağıdaki paketler bir başlangıç
            noktasıdır — size özel bir teklif için bizimle iletişime geçin.
          </p>
        </div>

        <div className="mt-16 grid lg:grid-cols-3 gap-6">
          {TIERS.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`pricing-card-${t.id}`}
              className={`relative rounded-3xl p-8 flex flex-col ${
                t.popular
                  ? "bg-[var(--ab-navy)] text-white border border-[var(--ab-navy)] lg:-translate-y-4 shadow-[0_40px_80px_-30px_rgba(45,63,255,0.45)]"
                  : "bg-white text-[var(--ab-navy)] border border-slate-200"
              }`}
            >
              {t.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 bg-[var(--ab-blue)] text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow-lg">
                  <Sparkles className="h-3.5 w-3.5" />
                  En Çok Tercih Edilen
                </div>
              )}

              <div>
                <div
                  className={`text-xs uppercase tracking-widest font-semibold ${
                    t.popular ? "text-blue-200" : "text-[var(--ab-blue)]"
                  }`}
                >
                  {t.badge}
                </div>
                <h3 className="font-display mt-2 text-3xl font-extrabold">
                  {t.name}
                </h3>
                <p
                  className={`mt-3 text-sm leading-relaxed ${
                    t.popular ? "text-blue-100" : "text-slate-600"
                  }`}
                >
                  {t.desc}
                </p>
                <div className="mt-6 pb-6 border-b border-slate-200/30">
                  <div className="font-display text-3xl font-bold">
                    {t.price}
                  </div>
                </div>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <span
                      className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${
                        t.popular
                          ? "bg-[var(--ab-blue)]/30"
                          : "bg-[var(--ab-blue)]/10"
                      }`}
                    >
                      <Check
                        className={`h-3 w-3 ${
                          t.popular ? "text-white" : "text-[var(--ab-blue)]"
                        }`}
                        strokeWidth={3}
                      />
                    </span>
                    <span className={t.popular ? "text-blue-50" : "text-slate-700"}>
                      {f}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`pricing-cta-${t.id}`}
                className={`mt-8 inline-flex items-center justify-center px-6 py-3.5 rounded-full text-sm font-semibold transition-all ${
                  t.popular
                    ? "bg-white text-[var(--ab-navy)] hover:bg-blue-50"
                    : "ab-btn-primary"
                }`}
              >
                Teklif Al
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
